<template>
  <div class="main">
    <div class="box">
      <div class="content">
        <div class="condition">筛选条件</div>
        <div class="form">
          <el-form :inline="true" :model="form" class="demo-form-inline">
            <el-form-item label="项目" label-width="110px">
              <el-select v-model="form.ProjectId" value-key="Id" placeholder="请选择" @change="ProjectChange" :class="{ classborder: border == 1 }">
                <el-option v-for="(item, index) in Project" :key="index" :label="item.Name" :value="item.Id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="查询类型">
              <el-select @change="changeType" v-model="form.searchType">
                <!-- <el-option label="简单查询" value="simple"></el-option>
                <el-option label="高级查询" value="complex"></el-option> -->
                <el-option v-for="itemc in searchOptions" :key="itemc.value" :label="itemc.label" :value="itemc.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关键字">
              <el-input v-model="form.key" placeholder="请输入关键字"></el-input>
            </el-form-item>
            <el-form-item label="数据集">
              <el-select multiple @change="changeTree" v-model="form.treeType">
                <el-option v-for="itemc in numberOption" :key="itemc.Id" :label="itemc.Name" :value="itemc.Id"></el-option>
              </el-select>
            </el-form-item>
            <el-row>
              <el-col></el-col>
            </el-row>
            <el-form-item label="开始时间" label-width="110px">
              <el-date-picker :picker-options="startDatePicker" v-model="form.StartTime" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker :picker-options="overDatePicker" v-model="form.EndTime" type="date" placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-form>
          <div>
            <el-button icon="el-icon-search" type="primary" @click="onSubmit">查询</el-button>
            <el-button @click="onRest" class="czhi">
              <img src="../../assets/image/icon/czhi.png" alt style="width: 14px; height: 14px" />
              重置
            </el-button>
          </div>
        </div>
        <!-- 数据集 -->
        <div class="condition">数据集</div>
        <div class="numberList">
          <div>
            <!-- <el-empty v-if="!treeLoading" description="等待加载数据"></el-empty> -->
            <el-tree
              node-key="Id"
              ref="tree"
              show-checkbox
              v-if="treeLoading"
              default-expand-all
              :props="defaultProps"
              :data="treeData"
              @node-click="handleNodeClick"
              @check-change="handleCheckChange"
            ></el-tree>
            <div v-if="!treeData.length">
              <el-empty description="暂无数据，请先选择顶部下拉的数据集"></el-empty>
            </div>
          </div>
          <div id="X">
            <!-- :disabled="checkBoxArr.length == 0" -->
            <el-button style="margin-left: 10px" @click="treeAdd">添加</el-button>
            <el-button @click="treeRemove">移除</el-button>
            <el-button @click="treeUp">上移</el-button>
            <el-button @click="treeDown">下移</el-button>
            <el-button @click="treeTop">置顶</el-button>
            <el-button @click="treeBottom">置底</el-button>
          </div>
          <div>
            <!-- <el-empty description="暂无数据，从左侧选择获取   "> -->
            <div
              @dragstart="dragstart(index)"
              @dragenter="dragenter($event, index)"
              @dragover="dragover($event, index)"
              draggable="true"
              :class="{ choseStyle: index == chosedIndex ? true : false, drags: true }"
              @click="choseIt(item, index)"
              v-for="(item, index) in choseArr"
              :key="index"
              style="text-align: center; cursor: pointer; height: 50px; border-bottom: 2px dashed #ccc; line-height: 50px"
            >
              <span style="line-height: 50px">{{ item.Name }}</span>
            </div>
            <div v-if="!choseArr.length">
              <el-empty description="暂无数据，请先选择左侧的数据集"></el-empty>
            </div>
          </div>
        </div>
        <!-- 高级查询 -->
        <div style="margin-top: 20px" v-if="form.searchType != 'simple' && shownb">
          <!-- 高级查询 -->
          <div class="condition">{{ searchOptionsObj[form.searchType] }}</div>
          <div class="form">
            <div class="nbSearch">
              <div class="nbSearch_child" v-for="(item, index) in nbForm" :key="index">
                <!-- 第一条显示 -->
                <div style="width: 100px; text-align: right; color: #666" v-if="index == 0">查询条件</div>
                <!-- 后面 是  或 和 与 -->
                <el-select v-if="index != 0" class="opAndOr" v-model="item.SelectType" placeholder="请选择">
                  <el-option v-for="itemc in opAndOr" :key="itemc.value" :label="itemc.label" :value="itemc.value"></el-option>
                </el-select>
                <!-- 真正的开始 后端获取options -->
                <el-select :loading="selectLoading" v-model="item.DataMappingId" placeholder="请选择" filterable>
                  <el-option v-for="itemc in options" :key="itemc.Id" :label="itemc.Name" :value="itemc.Id"></el-option>
                </el-select>
                <!-- 通过关系切换状态 /// 条件类型 0 首次  1末次 2 包含 3 未包含 4 等于 5 不等于
/// 6 大于 7 小于 8 值范围 -->
                <el-select @change="changeRelation(item, index)" v-model="item.ConditionalType" placeholder="请选择查询关系">
                  <el-option v-for="itemc in opRelations" :key="itemc.value" :label="itemc.label" :value="itemc.value"></el-option>
                </el-select>

                <!--  状态是 8 的时候考虑阈值范围 -->
                <el-input class="inputChose" v-if="item.ConditionalType == 8" placeholder="最大为" v-model="item.MaxVaule">
                  <div slot="suffix" class="flexAll_end">(最大值)</div>
                </el-input>
                <el-input class="inputChose" v-if="item.ConditionalType == 8" placseholder="最小为" v-model="item.MinVaule">
                  <div slot="suffix" class="flexAll_end">(最小值)</div>
                </el-input>
                <!-- 显示文本   为8加个插槽 v-if="item.ConditionalType != 2 && item.ConditionalType != 3 && item.ConditionalType != 8" -->
                <el-input style="margin-right: 30px" class="inputChose" v-model="item.Vaule" placeholder="请输入">
                  <div v-if="item.ConditionalType == 8" slot="suffix" class="flexAll_end">(倍数)</div>
                </el-input>
                <!--正常 之前之后 -->
                <el-select @change="timeChange(item, index)" v-model="item.EventConditional" placeholder="时间节点">
                  <el-option v-for="itemc in optionsTime" :key="itemc.value" :label="itemc.label" :value="itemc.value"></el-option>
                </el-select>
                <!-- 之前之后多少天 -->
                <el-input class="inputChose" v-if="item.EventConditional != 0" placseholder="时间单位(天)" v-model="item.EventDay">
                  <div slot="suffix" class="flexAll_end">(天)</div>
                </el-input>
                <!-- 换行 -->
                <div v-if="item.EventConditional != 0" style="width: 100%; height: 15px"></div>
                <!-- 后端获取options  第二行内容-->
                <div v-if="item.EventConditional != 0" style="width: 110px; height: 15px"></div>
                <el-select v-if="item.EventConditional != 0" v-model="item.EventDataMappingid" placeholder="请选择" filterable>
                  <el-option v-for="itemc in options" :key="itemc.Id" :label="itemc.Name" :value="itemc.Id"></el-option>
                </el-select>
                <el-select v-if="item.EventConditional != 0" @change="changeRelations(item, index)" v-model="item.EventConditionalType" placeholder="请选择查询关系">
                  <el-option v-for="itemc in opRelations2" :key="itemc.value" :label="itemc.label" :value="itemc.value"></el-option>
                </el-select>
                <el-input style="margin-right: 30px" v-if="item.EventConditional != 0" class="inputChose" v-model="item.EventVaule" placeholder="请输入">
                  <div v-if="item.EventConditionalType == 8" slot="suffix" class="flexAll_end">(倍数)</div>
                </el-input>
                <!--  -->
                <!-- 右侧按钮 -->
                <div class="flexAll">
                  <div style="margin-right: 10px" @click="toSearch(item, index)">
                    <i class="el-icon-search iconRight"></i>
                    <span>查询</span>
                  </div>
                  <div style="margin-right: 10px" @click="toAdd(item, index)">
                    <i class="el-icon-circle-plus-outline iconRight"></i>
                    <span>添加</span>
                  </div>
                  <div @click="toDel(item, index)">
                    <i class="el-icon-remove-outline iconRight"></i>
                    <span v-if="index != 0">删除</span>
                    <span v-if="index == 0">清空</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 高级查询搜索 -->
          <div style="width: 100%; display: flex; justify-content: flex-end">
            <el-button type="primary" icon="el-icon-search" @click="onSubmitFz">查询</el-button>
            <el-button @click="onRestFz" class="czhi">
              <img src="../../assets/image/icon/czhi.png" alt style="width: 14px; height: 14px" />
              重置
            </el-button>
          </div>
          <!-- v-if="tableData.length > 0"  -->
          <!-- <div style="width: 100%; display: flex; justify-content: flex-end; margin-top: 30px">
            <el-button type="success" icon="el-icon-download" @click="onExport">导出</el-button>
          </div> -->
        </div>
      </div>
      <div v-if="tableData?.length > 0" style="width: 100%; display: flex; justify-content: flex-end; margin-top: 30px">
        <el-button type="success" icon="el-icon-download" @click="onExport">导出</el-button>
      </div>
      <!-- 表格 -->
      <div v-if="searchShow && choseArr?.length > 0" class="table">
        <div class="con">
          <el-table
            max-height="600"
            ref="multipleTable"
            :data="tableData"
            style="margin-top: 20px; overflow: hidden !important; min-height: 450px"
            height="100%"
            :header-cell-style="{ 'text-align': 'center', background: 'rgb(240, 247, 253)' }"
            border
          >
            <!-- @select-all="selectAll"
          @selection-change="handleActivitySelectionChange"-->
            <!-- 动态表格添加 -->

            <el-table-column align="center" v-for="(item, index) in choseArr" :key="index" :label="item.Name" :prop="item.DataMappingId">
              <template slot="header" slot-scope="scope">
                <el-tooltip :content="scope.column.label">
                  <span>{{ scope.column.label }}</span>
                </el-tooltip>
              </template>
              <template slot-scope="{ row }">
                <span>{{ row[item.DataMappingId] ? row[item.DataMappingId] : 'N/A' }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="width: 98%; margin: 20 auto" class="pageStyle">
          <Pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.rows" @pagination="usePageNext"></Pagination>
        </div>
        <add-patient :type="2" @EditSonToFather="Editfather" :item="PatientList" v-if="dialogFlag" :dialog="dialogFlag"></add-patient>
      </div>
    </div>
  </div>
</template>

<script>
import tree from '@/api/tree';
import { generateNestedTree } from '@/utils/tree.js';
import { mapState } from 'vuex';
import ProjectManagement from '../../api/ProjectManagement';
import derive from '../../api/derive.js';
import smartSearch from '../../api/smartSearch.js';
import Pagination from '../../components/Pagination/index.vue';
import { local } from '../../utils/storage';

import { opAndOr, opRelations, opRelations2, options, optionsTime, searchOptions, searchOptionsObj } from '@/utils/dictionary.js';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      shownb: false,
      realTree: [],
      execelType: null,
      numberOption: [],
      mykey: '',
      tableData: [],
      searchShow: false,
      startDatePicker: {
        disabledDate: time => {
          if (this.form.EndTime) {
            return time.getTime() > new Date(this.form.EndTime);
          }
        }
      },
      overDatePicker: {
        disabledDate: time => {
          if (this.form.StartTime) {
            return time.getTime() < new Date(this.form.StartTime) - 1000 * 3600 * 24;
          }
        }
      },
      checkBoxArr: [],
      // 源对象的下标
      dragIndex: '',
      // 目标对象的下标
      enterIndex: '',
      timeout: null,

      chosedIndex: null,
      chosedItem: null,
      chosedItemLeft: null,
      choseArr: [],
      treeLoading: false,
      defaultProps: {
        children: 'children',
        label: 'Name',
        id: 'Id'
      },
      treeData: [],
      searchOptionsObj: searchOptionsObj,
      searchOptions: searchOptions,
      Project: [],
      selectLoading: false,
      tableSet: [],
      // pageTest: {
      //   page: 1,
      //   rows: 10,
      //   ProjectId: 'fe8c6ed8-1d8c-4f3d-89b2-7bc2d20aa892',
      //   ConditionalList: [
      //     {
      //       DataMappingId: '3B6E151B-C3F2-4E61-93E5-D7AB9191181C',
      //       ConditionalType: 0,
      //       Vaule: '炎',
      //       EventConditional: '1',
      //       EventDay: 365,
      //       EventDataMappingId: '3B6E151B-C3F2-4E61-93E5-D7AB9191181C',
      //       EventVaule: '风湿性关节炎'
      //     },
      //     {
      //       SelectType: '1',
      //       DataMappingId: '5F4A3244-C214-4610-8DEE-0C22F653D8E9',
      //       ConditionalType: 6,
      //       Vaule: '70'
      //     }
      //   ]
      // },
      options: [],
      form: {
        searchType: 'simple' // complex  simple
      },
      nbForm: [
        {
          ConditionalType: '',
          Vaule: '',
          EventConditional: 0
        }
      ],
      opRelations: opRelations,
      opRelations2: opRelations2,
      opAndOr: opAndOr,
      optionsTime: optionsTime,
      // 表格相关
      border: 0,
      PatientTable: [],
      admin: local.get('UserId'),
      devicePixelRatio: false,
      total: 0,
      pageSet: {
        key: '',
        page: 1,
        rows: 200
      },
      pageSetTree: {
        key: '',
        page: 1,
        rows: 1000
      },
      listQuery: {
        // Key: '',
        page: 1,
        rows: 10
      },
      pageRest: {
        page: 1,
        rows: 10
      },
      pageExcel: {
        page: 1,
        rows: 1000
      },
      dialogVisible: false,
      obj: {
        ProjectId: '',
        RobotId: '',
        ProjectPatientIds: []
      },
      activityMultipleSelection: [],
      value: {}
    };
  },
  watch: {
    'form.treeType'(val, oldVal) {
      if (!val) {
        this.choseArr = [];
        this.treeData = [];
      }
      console.log(val);
    }
  },
  // watch: {
  //   choseArr: {
  //     handler: function (val, oldVal) {
  //       console.log(val);
  //       this.tableSet = val.map(e => {
  //         return {
  //           DataMappingId: e.Id,
  //           Name: e.Name
  //         };
  //       });
  //       // this.$forceUpdate();
  //       console.log(this.tableSet);
  //     },
  //     deep: true
  //   }
  // },
  created() {
    //     new Vconsole();

    // this.value = {
    //   Id: 'all',
    //   Name: '全部'
    // };
    // this.ProjectList();

    // this.getData();
    this.ProjectList();
    this.getTreeData(this.pageSetTree);
  },
  destroyed() {
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timeout);
    this.timeout = null;
  },
  computed: mapState(['dialogFlag']),
  methods: {
    getDataTree(val) {
      tree.GetPageList(val).then(res => {
        const arr = generateNestedTree(res.data.Data.rows);
        console.log(arr);
        this.tableData1 = arr;
        console.log(this.tableData1);
      });
    },
    async onExport(val) {
      if (!this.execelType) {
        var params = { ...this.form, ...this.pageExcel, ShowColumnlist: this.choseArr };
      } else {
        var params = { ConditionalList: this.nbForm, ...this.pageExcel, ShowColumnlist: this.choseArr };
      }
      await smartSearch.NewQueryParentListBySynchronization(params).then(e => {
        const updatedArray = e.data.Data.map(obj => {
          const updatedObj = {};
          Object.keys(obj).forEach(key => {
            if (obj[key] === '' || obj[key] === null || obj[key] === undefined) {
              updatedObj[key] = 'N/A';
            } else {
              updatedObj[key] = obj[key];
            }
          });
          return updatedObj;
        });
        console.log(updatedArray);

        this.tableDataExcel = updatedArray;
        console.log(this.tableData);
      });
      import('@/utils/excelSpecial').then(excel => {
        const tHeader = this.choseArr.map(e => {
          return e.Name;
        });
        const filterVal = this.choseArr.map(e => {
          return e.DataMappingId;
        });
        console.log(tHeader, filterVal, 7788);
        const list = this.tableDataExcel;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '数据分析表',
          autoWidth: true,
          bookType: 'xlsx'
        });
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    },
    changeTree(val) {
      this.shownb = false;
      console.log(this.form.treeType, 7788);
      // [
      //   {
      //     Name: '健康状况',
      //     DataMappingId: '43c23a96-4c1e-4e84-9e4f-130d6a83b303',
      //     ParentId: '9260d95f-f9f6-45d3-be01-089bac65b3bc',
      //     DateRule: 0,
      //     StartTime: null,
      //     EndTime: null,
      //     IsFill: false,
      //     FillCount: null,
      //     FillRate: null,
      //     Id: 'fa93d6f1-badf-4cef-b581-4288a7d17106',
      //     OrganizationId: null,
      //     CreatedBy: null,
      //     CreateTime: '2023-08-22 15:42:56',
      //     UpdatedBy: null,
      //     UpdateTime: null,
      //     Status: null
      //   }
      // ];
      if (val.length === 0) {
        this.choseArr = [];
        this.nbForm = [];
      }
      this.choseArr = [];
      console.log(val);
      console.log(this.realTree);
      const tree = JSON.parse(JSON.stringify(this.realTree));
      const filteredParentNodes = tree.filter(node => val.includes(node.Id));
      console.log(filteredParentNodes);
      this.treeData = filteredParentNodes;
      // tree.GetListId(val).then(e => {
      //   console.log(val);
      //   const arrs = e.data;
      //   console.log(e.data);
      //   let arr = generateNestedTree(arrs);
      //   console.log(arr);
      //   this.treeData = arr;
      //   console.log(arr);
      // });
    },

    getListId(id) {
      tree.GetListId(id).then(e => {
        console.log(e, 77);
      });
    },

    handleCheckChange(data, checked, indeterminate) {
      let arr = this.$refs.tree.getCheckedNodes(false, true);
      console.log(arr);
      // 去除arr 的 子项中的children 属性，并且去除ParentId是0的项
      arr = arr
        .filter(item => {
          return item.ParentId !== '0';
        })
        .map(e => {
          delete e.children;
          return e;
        });
      console.log(arr);
      this.checkBoxArr = arr;
      console.log(arr);
    },
    // 拖拽
    dragstart(index) {
      this.chosedIndex = index;
    },
    dragenter(e, index) {
      e.preventDefault();
      if (this.timeout !== null) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        if (this.dragIndex !== index) {
          // const source = this.list[this.dragIndex]
          // this.list.splice(this.dragIndex,1)
          // this.list.splice(index, 0 , source )
          // // 排序变化后目标对象的索引变成源对象的索引
          // this.dragIndex = index;
          this.choseArr.splice(index, 0, this.choseArr.splice(this.chosedIndex, 1)[0]);
          this.chosedIndex = index;
        }
      }, 100);
    },
    dragover(e, index) {
      e.preventDefault();
    },
    // tree
    async treeAdd() {
      if (this.$refs.tree) {
        const arr = this.$refs.tree.setCheckedKeys([]);
      } else {
        return;
      }

      if (this.checkBoxArr.length === 0) {
        return;
      }
      // IsDisplay 为true
      this.checkBoxArr = this.checkBoxArr.filter(e => {
        return e.IsDisplay === true;
      });
      console.log(this.checkBoxArr, 66);
      this.choseArr.push(...this.checkBoxArr);
      this.choseArr = [...new Set(this.choseArr)];
      this.nbForm = [
        {
          ConditionalType: '',
          Vaule: '',
          EventConditional: 0
        }
      ];
      await this.getList();
      this.shownb = true;
      console.log(this.choseArr);
    },
    treeRemove() {
      if (this.choseArr.length === 0) {
        return;
      }
      if (!this.chosedItem) {
        this.$message.warning('请先选择要操作的字段');
        return;
      }
      this.choseArr.splice(this.chosedIndex, 1);
      if (this.chosedIndex > 0) {
        this.chosedIndex = this.chosedIndex - 1;
        console.log(this.chosedIndex);
      }

      // 当删除的是最后一个时，索引取消
      // if (this.chosedIndex === 0) {
      //   this.chosedIndex = null;
      // }
    },
    treeUp() {
      if (this.choseArr.length === 0) {
        return;
      }
      if (!this.chosedItem) {
        this.$message.warning('请先选择要操作的字段');
        return;
      }
      const temp = this.choseArr[this.chosedIndex];
      this.choseArr.splice(this.chosedIndex, 1);
      this.choseArr.splice(this.chosedIndex - 1, 0, temp);
      // 上移之后，目标对象的索引变成源对象的索引
      this.chosedIndex = this.chosedIndex - 1;
      this.$forceUpdate();
      console.log(this.choseArr);
    },
    treeDown() {
      if (this.choseArr.length === 0) {
        return;
      }
      if (this.chosedIndex === this.choseArr?.length - 1) {
        return;
      }
      if (!this.chosedItem) {
        this.$message.warning('请先选择要操作的字段');
        return;
      }
      const temp = this.choseArr[this.chosedIndex];
      this.choseArr.splice(this.chosedIndex, 1);
      this.choseArr.splice(this.chosedIndex + 1, 0, temp);
      // 下移之后，目标对象的索引变成源对象的索引
      this.chosedIndex = this.chosedIndex + 1;
    },
    treeTop() {
      if (this.choseArr.length === 0) {
        return;
      }
      if (!this.chosedItem) {
        this.$message.warning('请先选择要操作的字段');
        return;
      }
      const temp = this.choseArr[this.chosedIndex];
      this.choseArr.splice(this.chosedIndex, 1);
      this.choseArr.splice(0, 0, temp);
      this.chosedIndex = 0;
    },
    treeBottom() {
      if (this.choseArr.length === 0) {
        return;
      }
      if (!this.chosedItem) {
        this.$message.warning('请先选择要操作的字段');
        return;
      }
      const temp = this.choseArr[this.chosedIndex];
      this.choseArr.splice(this.chosedIndex, 1);
      this.choseArr.splice(this.choseArr?.length, 0, temp);
      this.chosedIndex = this.choseArr?.length - 1;
    },

    choseIt(item, index) {
      this.chosedItem = item;
      this.chosedIndex = index;
    },
    handleNodeClick(val) {
      this.chosedItemLeft = val;
      // 选中该节点，将数据push到 choseArr中，有重复的就去重

      console.log(val);
    },
    // 获取树的数据
    getTreeData(val) {
      tree.GetPageList(val).then(res => {
        this.treeLoading = true;
        console.log(res.data.Data.rows);
        this.realTree = generateNestedTree(res.data.Data.rows);
        // const arr = generateNestedTree(res.data.Data.rows);
        const arrNew = res.data.Data.rows.filter(e => {
          return e.ParentId === '0';
        });

        this.numberOption = arrNew;
      });
    },
    usePageNext() {
      // 这里要判断 走的 是 简单查询还是 高级查询
      if (this.form.searchType == 'simple') {
        var params = {
          ...this.listQuery,
          ...this.form,
          ShowColumnlist: this.choseArr
        };
      } else {
        var params = { ConditionalList: this.nbForm, ...this.listQuery };
      }
      this.getData(params);
    },
    onRestFz() {
      this.nbForm = [
        {
          ConditionalType: '',
          Vaule: '',
          EventConditional: 0
        }
      ];
      this.pageSet = {
        page: 1,
        rows: 10
      };
      const params = { ConditionalList: this.nbForm, ...this.pageRest };
      this.getData(params);
    },
    onSubmitFz() {
      this.execelType = 1;
      // 处理选中的数组 取出他们的id集合
      // const arr = this.choseArr.map(e => {
      //   return e.Id;
      // });

      // 如果项目id为空 警告
      if (!this.form.ProjectId) {
        this.$message({
          message: '请选择项目',
          type: 'warning'
        });
        return;
      }
      // 如果数据集为空 警告
      if (this.choseArr?.length === 0) {
        this.$message({
          message: '请选择数据集，置入右侧已选项中',
          type: 'warning'
        });
        return;
      }
      const params = { ConditionalList: this.nbForm, ...this.pageRest, ShowColumnlist: this.choseArr };
      this.getData(params);
      this.searchShow = true;
      console.log('🚀 ~ file: smartSearch.vue:410 ~ onSubmitFz ~ params:', params);
      console.log('submit!');
    },
    onRest() {
      this.form = {
        searchType: 'simple',
        key: '',
        StartTime: '',
        EndTime: '',
        ProjectId: ''
      };
      const params = { ...this.pageRest, ...this.form };
      this.getData(params);
    },
    timeChange(item, index) {
      const arr = ['EventDay', 'EventDataMappingid', 'EventConditionalType', 'EventVaule'];
      arr.forEach(e => {
        this.$set(this.nbForm[index], e, '');
      });
      // this.$set(this.nbForm);
      console.log(item, index);
    },
    toSearch(item, index) {
      this.execelType = 1;
      // 如果项目id为空 警告
      if (!this.form.ProjectId) {
        this.$message({
          message: '请选择项目',
          type: 'warning'
        });
        return;
      }
      // 如果数据集为空 警告
      if (this.choseArr?.length === 0) {
        this.$message({
          message: '请选择数据集，置入右侧已选项中',
          type: 'warning'
        });
        return;
      }
      this.searchShow = true;
      console.log(item);
      const params = { ConditionalList: [item], ...this.pageRest, ShowColumnlist: this.choseArr };
      this.getData(params);
      console.log('🚀 ~ file: smartSearch.vue:136 ~ toSearch ~ item:', item);
    },
    toDel(item, index) {
      if (this.nbForm?.length === 1) {
        this.nbForm = [
          {
            ConditionalType: '',
            Vaule: '',
            EventConditional: 0
          }
        ];
        return;
      }
      this.nbForm.splice(index, 1);
      console.log(item, index);
    },
    onSubmit() {
      this.execelType = 0;
      // 如果项目id为空 警告
      if (!this.form.ProjectId) {
        this.$message({
          message: '请选择项目',
          type: 'warning'
        });
        return;
      }
      // 如果数据集为空 警告
      if (this.choseArr?.length === 0) {
        this.$message({
          message: '请选择数据集，置入右侧已选项中',
          type: 'warning'
        });
        return;
      }
      const params = { ...this.form, ...this.pageRest, ShowColumnlist: this.choseArr };
      this.searchShow = true;
      this.getData(params);
      console.log('submit!');
    },
    toAdd(item, index) {
      this.nbForm.push({
        ConditionalType: '',
        Vaule: '',
        SelectType: '',
        MaxVaule: '',
        MinVaule: '',
        EventConditional: 0
      });
    },
    // 简单查询表头搜索
    changeType(val) {
      console.log(val);
      // this.listQuery.page = 1;
      if (val === 'simple') {
        this.form.user = '';
        this.form.region = '';
        // var params = {
        //   ...this.listQuery,
        //   ...this.form
        // };
      } else {
        console.log(this.choseArr);
        // var params = { ConditionalList: this.nbForm, ...this.listQuery };
        if (this.choseArr.length) {
          console.log(123456);
          this.nbForm = [
            {
              ConditionalType: '',
              Vaule: '',
              EventConditional: 0
            }
          ];
        } else {
          this.nbForm = [];
        }
      }
      // this.getData(params);
    },
    // 高级关系
    changeRelation(val, index) {
      const arr = ['Vaule', 'MinVaule', 'MaxVaule', 'EventDay', 'EventDataMappingid', 'EventConditionalType', 'EventVaule'];
      arr.forEach(e => {
        this.$set(this.nbForm[index], e, '');
      });
      console.log(val, index);
    },
    changeRelations(val, index) {
      const arr = ['EventVaule'];
      arr.forEach(e => {
        this.$set(this.nbForm[index], e, '');
      });
      console.log(val, index);
    },

    // 表格方法**********************************
    sortByRisk(obj1, obj2) {
      if (obj2.RiskRating > obj1.RiskRating) {
        return 1;
      } else {
        return -1;
      }
      // console.log(obj1.RiskRating)
    },
    sortByVesselName(obj1, obj2) {
      if ([obj1.Name, obj2.Name][0] == [obj1.Name, obj2.Name].sort((a, b) => a.localeCompare(b, 'zh', { sensitivity: 'accent' }))[0]) {
        return -1;
      } else {
        return 1;
      }
    },
    //项目
    async ProjectList() {
      derive.ProjectListData().then(res => {
        console.log(res);
        if (res.data.Status == 1) {
          if (res.data.Data?.length != 0) {
            // this.QProject = JSON.parse(JSON.stringify(res.data.Data));
            // this.Project=res.data.Data;
            //初始化Project
            this.Project = [
              // {
              //   Name: '全部',
              //   Id: 'all'
              // },
              // {
              //   Name: '其他',
              //   Id: 'other'
              // }
            ];
            res.data.Data.forEach(item => {
              this.Project.push(item);
            });

            // let Objall={
            //     Name:"全部",

            //     Id:"all",
            // }
            // let ObjOther={
            //     Name:"其他",
            //     Id:"other",
            // }
            // this.value = {
            //   Id: 'all',
            //   Name: '全部'
            // };
            // local.set('IsRtc', true);
            // this.Project.unshift(ObjOther)
            // this.Project.unshift(Objall)
            // this.ProjectGetPageList(this.value.Id);
          }
        } else {
          // alert(res.data.Message);
        }
      });
    },
    //项目患者列表
    ProjectGetPageList(Id) {
      const parameter = {
        projectId: Id,
        Key: this.listQuery.Key,
        page: this.listQuery.page,
        rows: this.listQuery.rows,
        BeginTime: this.StartTime,
        EndTime: this.EndTime
      };
      ProjectManagement.QGetPageListData(parameter).then(res => {
        if (res.data.Status == 1) {
          this.PatientTable = res.data.Data.rows.map(item => {
            item.CreateTime = item.CreateTime.substring(0, 10);
            if (item.Birthday) {
              item.Birthday = item.Birthday.substring(0, 10);
            }
            return item;
          });
          this.total = res.data.Data.total;
          this.$nextTick(() => {
            this.activityMultipleSelection.forEach(row => {
              this.PatientTable.forEach(p => {
                if (p.Id == row.Id) {
                  this.$refs.multipleTable.toggleRowSelection(p);
                }
              });
            });
          });
        } else {
          alert(res.data.Message);
        }
      });
    },
    //项目选择后的回调
    ProjectChange(item) {
      // this.obj.ProjectId = '';
      // if (item.Id == 'all' || item.Id == 'other') {
      //   local.set('IsRtc', true);
      // } else {
      //   this.obj.ProjectId = item.Id;
      //   local.set('IsRtc', item.IsRtc);
      // }
      // this.ProjectGetPageList(item.Id);
      console.log(item);
      this.pageRest.ProjectId = item;
      this.listQuery.ProjectId = item;
      this.pageExcel.ProjectId = item;
      // this.getData(this.pageTest);
    },
    PatientPortrait(row) {
      this.$router.push({
        path: '/PatientPortrait',
        query: { Id: this.$route.query.Id, qId: row.Id }
      });
    },
    // 查询条件下拉查询 现在  **********************
    getList() {
      this.pageSet.rows = this.choseArr.length;
      const DataMappingIdList = this.choseArr.map(e => {
        return e.DataMappingId;
      });
      const params = {
        ...this.pageSet,
        DataMappingIdList: DataMappingIdList
      };
      this.selectLoading = true;
      smartSearch.GetPageList(params).then(e => {
        this.selectLoading = false;

        let arr = e.data.Data.rows;
        arr.forEach(item => {
          if (item.System === '' || item.System === null) {
            return;
          } else {
            item.Name = item.Name + '(' + item.System + ')';
          }
        });

        this.options = arr;
        console.log(e.data.Data.rows);
      });
    },
    //打开问卷填写
    QuestionnaireFilling(row) {
      const h = this.$createElement;
      this.$confirm('', {
        message: h('div', null, [
          h('i', {
            class: 'el-icon-question',
            style: 'color:#f90;font-size:30px;'
          }),
          h(
            'span',
            {
              style: 'margin-left:10px;font-size:16px;line-height:30px;font-weight:600;vertical-align:top;'
            },
            '提示'
          ),
          h('p', { style: 'margin:10px 0 0 40px;font-size:20px' }, '是否新增一份问卷吗？'),

          h(
            'p',
            {
              style: 'text-align: center;line-height:18px;position: absolute;bottom:-110px'
            },
            [h('span', { style: 'color:red;font-weight:800' }, '温馨提示: '), h('span', {}, '如果想要继续填写“已填写过的问卷”，请到“已收集问卷”或“随访记录”中继续填写即可!')]
          )
        ]),
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'diyModel',
        closeOnClickModal: false,
        closeOnPressEscape: false
      }).then(() => {
        if (!row.CallBackInfo.IsSuccess) {
          alert(row.CallBackInfo.Msg);
          return;
        }
        if (row.ProjectId == null) {
          alert('该患者不属于任何项目,无法填写问卷');
        } else {
          this.persionInfo = row;
          this.PObj = row;
          this.dialogVisible = true;
          this.Url = '';
          this.Qval = '';
          this.QuestionnaireGetPageList(row.ProjectId);
          this.PatientProfiling();
        }
      });
    },
    getData(data) {
      smartSearch.NewQueryParentListBySynchronization(data).then(e => {
        this.tableData = e.data.Data;
        this.total = e.data.total;
        console.log(this.tableData);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.main {
  font-size: 16px;
  width: 100%;
  min-width: 1440px;
  /* height: 100%; */
  overflow: hidden;
  .box {
    width: calc(100% - 40px);
    height: calc(100% - 40px);
    margin: 0 auto;
    border-radius: 10px;
    background: #fff;

    .content {
      /* height: 100%; */
      margin-top: 20px;
      background: #fff;
      padding: 20px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
    }
    .table {
      padding: 20px;
      flex: 1;
      display: flex;
      flex-direction: column;
    }
    .con {
      width: 100%;
      height: 90% !important;

      /deep/.el-table__fixed-right-patch {
        width: 9px !important;
        background-color: rgb(240, 247, 253) !important;
      }
    }

    .robotVisibledia {
      width: 60% !important;
    }
  }
}
.condition {
  padding: 0 8px;
  border-left: 5px solid #7794fe;
}
.form {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 20px;
  .demo-form-inline {
    .el-form-item {
      margin-right: 0;
    }
  }
  ::v-deep() {
    .el-form-item {
      margin-right: 50px !important;
    }
  }
}
.nbSearch {
  .nbSearch_child {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 15px;
    & > div:first-child {
      margin-right: 10px;
    }
    ::v-deep() {
      .el-select {
        margin-right: 10px !important;
      }
    }
  }
}
.flexAll {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #409eff;
  cursor: pointer;
}
.flexAll_end {
  height: 100%;
  display: flex;
  align-items: center;
}

.opAndOr {
  width: 100px;
}
.inputChose {
  width: 200px;
  margin-right: 10px;
}
.iconRight {
  margin-right: 5px;
}

.numberList {
  width: 100%;
  height: 350px;

  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 10px;
  .el-input {
    width: 100px;
    margin-right: 10px;
  }
  & > div:nth-child(1) {
    height: 100%;
    width: 45%;
    overflow: auto;

    border: 1px solid #ccc;
  }
  & > div:nth-child(2) {
    height: 100%;
    width: 10%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    .el-button {
      width: 100%;
      margin: none !important;
    }
  }
  & > div:nth-child(3) {
    height: 100%;
    width: 40%;
    display: flex;
    flex-direction: column;
    align-items: space-around;
    overflow: auto;
    border: 1px solid #ccc;
  }
}
.choseStyle {
  background: #e7f1ff;
}
/deep/ .el-tree-node__content {
  height: 50px;
}
/deep/ .el-tree-node__label {
  font-size: 16px;
}
/* /deep/ .el-tree-node.is-current > .el-tree-node__content {
  background: rgba(22, 119, 255, 0.1);
  border-right: 3px solid #1677ff;
  color: #187aff;
  /deep/ .el-tree-node__expand-icon {
    color: rgb(0, 112, 255);
  }
  /deep/ .is-leaf {
    color: rgba(0, 0, 0, 0);
  }
} */
.drags {
  transition: transform 0.3s;
  cursor: move;
}
/deep/ .el-input__inner {
  width: 220px;
}
.pageStyle {
  margin-top: 20px;
  /deep/ .el-input__inner {
    width: 100px;
  }
}

/deep/ .el-table {
  th {
    .cell {
      white-space: nowrap !important;
      text-overflow: ellipsis;
      /* word-break: break-all; */
      /* width: 200px !important; */
      overflow: hidden;
    }
  }
}
/deep/ .el-tree__empty-block {
  display: none !important;
}
</style>
